import { useTranslation } from 'react-i18next'

import { Status } from '../../../Status'
import Text from '../../../Text'
import { CalendarItemTag } from '../../CalendarItemTag'

import { getCalendarItemCardStatusTags } from './CalendarItemCardTags.utils'

import * as styles from './CalendarItemCardTags.module.css'

function CalendarItemCardTags({ isAllDay, isArchived, isDue, kind }) {
  const { t } = useTranslation()

  return (
    <div className={styles.CalendarItemCardTags}>
      <CalendarItemTag item={{ kind }} />
      {isAllDay ? <Text isSecondary>{t('Calendar.AllDayKey')}</Text> : null}
      {getCalendarItemCardStatusTags({ isArchived, isDue }).map(tag => (
        <Status {...tag} key={tag.text} text={t(tag.text)} />
      ))}
    </div>
  )
}

export default CalendarItemCardTags
